export const mobHeaderStyle = {
	container: {
		backgroundColor: 'var(--primary-500)',
		height: '100px',
		display: ' flex',
		alignItems: 'center',
		padding: '44px 20px 16px',
		gap: '16px',
		position: 'relative',

		'@media (min-width: 640px)': {
			padding: '0 40px',
			alignItems: 'center',
		},

		svg: {
			width: '24px',
			height: '24px',
			path: {
				fill: 'var(--default-white)',
			},

			'@media (max-width: 639.98px)': {
				width: '20px',
				height: '20px',
			},
		},
	},

	title: {
		fontWeight: 700,
		color: 'var(--default-white)',
		fontSize: '20px',
		display: 'flex',
		alignItems: 'center',

		'@media (min-width: 640px)': {
			fontSize: '24px',
			position: 'absolute',
			left: '50%',
			top: '50%',
			transform: 'translate(-50%, -50%)',
			width: 'max-content',
			textAlign: 'center',
		},
	},

	notify: {
		position: 'absolute',
		right: '40px',
		bottom: '18px',
		color: 'var(--default-white)',
		fontSize: '16px',
		fontWeight: 700,
		cursor: 'pointer',
		padding: '10px 16px',
		border: '1px solid var(--default-white)',
		borderRadius: '8px',
		height: '48px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',

		'@media (max-width: 639.98px)': {
			height: '40px',
			right: '20px',
		},
	},

	actions: {
		position: 'absolute',
		right: '40px',
		bottom: '18px',

		'@media (min-width: 768px)': {
			display: 'none',
		},
	},
	modal: {
		'.MuiPaper-root': {
			position: 'relative',
			maxWidth: '1170px',
			width: '100%',
			padding: '48px 120px',
			margin: '0 15px',

			'@media (max-width: 639.98px)': {
				padding: '40px 20px 20px',
			},
		},
	},
};
